import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { trackEvent } from 'helpers/Analytics';
import UserCard2 from 'components/Shared/UserCard2/UserCard2';
import Panel from 'components/Panel/Panel';
import styles from './PinderNewTabUserCard.module.scss';
import Price from 'components/Price/Price';
import { isCreativeJob } from 'helpers/HelperFunctions';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import Icon from 'components/Icon/Icon';
import TimeAgo from 'components/TimeAgo/TimeAgo';
import Modal from 'components/Modal/Modal';
import PaymentModal from 'components/Pitch/PaymentModal';

const PinderNewUserCard = ({
  pitch,
  userCardRef,
  brief,
  pitchListProps,
  user,
  handleDislike,
  handleLike,
}) => {
  const [showAcceptPitch, setShowAcceptPitch] = useState(false);

  const { onAccepted, ...rest } = pitchListProps;

  const showPaymentProcessor = () => {
    setShowAcceptPitch(true);
  };

  const onAccept = (totalToPay) => {
    onAccepted(pitch, totalToPay * 100);
    setShowAcceptPitch(false);
  };

  const isCreativeUser = () => {
    const [firstRole] = pitch.sender ? pitch.sender.top_roles : [''];
    if (firstRole && isCreativeJob(firstRole)) {
      return true;
    }
    return false;
  };

  const handleHireOthers = () => {
    setShowAcceptPitch(false);
    window.location.href = brief.links.ats_main_relative;
  };

  const handleMessageUser = () => {
    setShowAcceptPitch(false);
    window.location.href = `/messages/` + pitch.sender.username;
  };

  return (
    <Fragment>
      <Panel className={styles.gridContainer}>
        <UserCard2
          pitch={pitch}
          user={pitch && pitch.sender}
          ref={userCardRef}
          preferredRole={brief?.role}
          customStylesheet={styles}
        />
        <div
          className={`${styles.HiringInfoContainer} ${
            isCreativeUser() ? styles.creativeUser : ''
          }`}
        >
          {pitch.day_rate && (
            <div
              className={styles.dayRateMobile}
              style={{ whiteSpace: 'pre-wrap' }}
            >
              <span>
                Standard rate:{' '}
                <Price
                  currency={pitch.day_rate_currency}
                  amount={pitch.day_rate}
                  rounded
                />{' '}
                /day
              </span>
            </div>
          )}
          {pitch.amount > 0 && (
            <div className={styles.feeInfo}>
              {pitch?.commission && (
                <>
                  <div className={`${styles.pitchFee} ${styles.feeLine}`}>
                    <span>{`${pitch?.sender?.displayname}'s fee`}:</span>
                    <Price
                      currency={brief?.currency}
                      amount={pitch?.commission?.jobFee}
                    />
                  </div>
                  <div className={`${styles.serviceCharge} ${styles.feeLine}`}>
                    <span>Service charge:</span>
                    <Price
                      currency={brief?.currency}
                      amount={pitch?.commission?.twineFee}
                    />
                  </div>
                  <div className={`${styles.processingFee} ${styles.feeLine}`}>
                    <span>Card processing:</span>
                    <Price
                      currency={brief?.currency}
                      amount={pitch?.commission?.cardFee}
                    />
                  </div>
                  <hr className={styles.hrBlock} />
                  <div className={`${styles.total} ${styles.feeLine}`}>
                    <span>Total:</span>
                    <Price
                      currency={brief?.currency}
                      amount={pitch?.commission?.totalPayment}
                    />
                  </div>
                </>
              )}
            </div>
          )}
          {pitch.accepted_at === '' && pitch.declined_at === '' && (
            <>
              <LinkContainer
                to={'/messages/' + pitch.sender.username}
                className={styles.messageButtonMobile}
              >
                <Button
                  bsStyle="info"
                  onClick={() => {
                    trackEvent('pitch-discuss-project', {
                      brief: brief.id,
                      pitch: pitch.id,
                    });
                  }}
                >
                  <div className={styles.buttonWithSvg}>
                    Reply{' '}
                    <SvgIcon
                      className={styles.replySvg}
                      size="14px"
                      icon="bubble"
                    />
                  </div>
                </Button>
              </LinkContainer>
              <Button
                className={styles.hireButtonMobile}
                bsStyle="success"
                onClick={() => {
                  showPaymentProcessor();
                }}
              >
                Hire <Icon className={styles.icon} icon="&#xe60c;" />
              </Button>
            </>
          )}
          <div className={styles.hiringInfo}>
            {pitch?.timestamp && (
              <div className={styles.pitchAge}>
                Submitted <TimeAgo timestamp={pitch.timestamp} />
              </div>
            )}
            {pitch.day_rate && (
              <div
                className={styles.dayRate}
                style={{ whiteSpace: 'pre-wrap' }}
              >
                <span>
                  Standard rate:{' '}
                  <Price
                    currency={pitch.day_rate_currency}
                    amount={pitch.day_rate}
                    rounded
                  />{' '}
                  /day
                </span>
              </div>
            )}
            {pitch.accepted_at === '' && pitch.declined_at === '' && (
              <>
                <LinkContainer
                  to={'/messages/' + pitch.sender.username}
                  className={styles.messageButton}
                >
                  <Button
                    bsStyle="info"
                    onClick={() => {
                      trackEvent('pitch-discuss-project', {
                        brief: brief.id,
                        pitch: pitch.id,
                      });
                    }}
                  >
                    <div className={styles.buttonWithSvg}>
                      Discuss project{' '}
                      <SvgIcon
                        className={styles.replySvg}
                        size="14px"
                        icon="bubble"
                      />
                    </div>
                  </Button>
                </LinkContainer>
                <Button
                  className={styles.hireButton}
                  bsStyle="success"
                  onClick={() => {
                    showPaymentProcessor();
                  }}
                >
                  Hire <Icon className={styles.icon} icon="&#xe60c;" />
                </Button>
              </>
            )}
          </div>
        </div>
      </Panel>
      <div className={`${styles.actions} `}>
        <div className={styles.btnContainer}>
          <Button
            bsSize="large"
            bsStyle="primary"
            onClick={() => handleLike(pitch.id)}
          >
            <div className={styles.buttonWithSvg}>
              <span className={styles.btnDesktopCTA}>👍&nbsp;&nbsp;Add to</span>
              Shortlist
            </div>
          </Button>
          <Button
            bsSize="large"
            bsStyle="info"
            onClick={() => handleDislike(pitch)}
          >
            👎&nbsp;&nbsp;Not interested
          </Button>
        </div>
      </div>
      <Modal
        closeButton
        show={showAcceptPitch}
        title={
          pitch.accepted_at
            ? `Hired ${pitch?.sender?.displayname}`
            : `Hire ${pitch?.sender?.displayname}`
        }
        onExit={() => setShowAcceptPitch(false)}
      >
        <PaymentModal
          brief={brief}
          pitch={pitch}
          onAccept={(totalToPay) => onAccept(totalToPay)}
          clientid={user?.id}
          clientemail={user?.email}
          hireOthers={() => handleHireOthers()}
          closeModal={() => handleMessageUser()}
        />
      </Modal>
    </Fragment>
  );
};

PinderNewUserCard.propTypes = {
  pitch: PropTypes.object,
  brief: PropTypes.object,
  pitchListProps: PropTypes.object,
  user: PropTypes.object,
  handleDislike: PropTypes.func,
  handleLike: PropTypes.func,
};

export default connect(({ auth: { user } }) => ({ user }))(PinderNewUserCard);
